import { AbstractModalService } from '@/core/modals/AbstractModalService';
import { ModalOptions } from '@/core/modals/ModalState';
import { FacetValueViewObject } from '@/types/apiServerContract';

class ProductAccessoriesCategroyOverlayService extends AbstractModalService {
    public show(
        categories: FacetValueViewObject[] | null,
        options?: Partial<ModalOptions>
    ) {
        return this.showModal({
            component: () => import(
                /* webpackPrefetch: true */
                '@/project/product/product-tile/ProductAccessoriesCategoryOverlay.vue'),
            componentAttrs: {
                categories
            },
            options: {
                placement: 'center',
                usePanelWrapper: false,
                closeOnRouteChange: true,
                closeOnBreakpointChange: true,
                ...options
            }
        });
    }
}

export default new ProductAccessoriesCategroyOverlayService();
